export const ue_text = function () {
  return (
    <>
      <p style={{ color: "black", marginTop: "50px" }}>
        Fondul Social European, Programul Operațional Capital Uman 2014 – 2020
        Axa prioritară 6 Educație și competențe Obiectivul specific 6.13
        Creșterea numărului absolvenților de învățământ terțiar universitar și
        non universitar care își găsesc un loc de muncă urmare a accesului la
        activități de învățare la un potențial loc de muncă / cercetare/
        inovare, cu accent pe sectoarele economice cu potențial competitiv
        identificate conform SNC și domeniile de specializare inteligentă
        conform SNCDI Proiect „SIA - Studenți Inovatori, viitori Antreprenori”,
        ID 140494 In urma proiectului am creat 2 locuri de munca pentru 2
        studenti in ani terminali la facultatea de Autovehicule Rutiere din
        cadrul UTCN. În cadrul măsurilor de inovare sociala, dupa cum se știe
        timpul este o problema la majoritatea clientilor, fie ei persoane fizice
        sau juridice, asadar am identificat un serviciu pe care l-am putea
        implementa in urmatoarea perioada, pentru a veni in ajutorul clientilor
        si a comunității vizata, vom incerca sa oferim un servciu de prestare
        pentru anumite tipuri de reparații si diagnoze la domiciliul clientului.
        Cu ajutorul unor campanii lunare, vom incerca sa venim in ajutorul
        clientilor care nu au o situatie materiala foarte buna si ii vom ajuta
        sa facă anumite reparatii costisitoare prin intermediul nostru ,
        contribuind astfel la siguranta participantilor la trafic si a
        conducatorilor auto. Echipamentele folosite sunt de ultimă generație
        facilitand astfel timpul de prestare al serviciilor si calitatea
        acestora. Dezvoltare durabilă (reducerea poluării și a emisiilor de CO2,
        utilizarea eficientă a resurselor, protecția mediului, soluții eficiente
        pentru utilizarea rațională a resurselor, etc) Service-ul doreste sa
        reduca impactul asupra mediului, prin operatiuni de reciclare a
        uleiurilor, in momentul in care clienti isi schimba uleiul de motor,
        uleiul uzat trebuie eliminat în mod responsabil. In mare parte, ne vom
        externa serviciile de colectare a deseurilor selective, pentru a reusi
        sa reciclam cat mai multe consumabile si piese auto, pentru a preveni
        impactul major asupra mediului si asupra populatiei. In cazul unei
        eventuale noi pandemii la nivel mondial, vom avea un plan pentru
        distantarea peronalului in cadrul spatiului de lucru si vom limita
        contactul fizic cu clientul, avand in vedere toate masurile de protectie
        si siguranta in vederea combaterii bolilor. Egalitate de șanse și
        nediscriminare (în rândul angajaților, politică salarială, accesul
        persoanelor cu dizabilități etc) Egalitatea dintre cetateni este un
        drept garantat prin Constitutia Romaniei. Aceasta prevede drepturi egale
        pentru toti romanii indiferent de rasa, nationalitate, origine etnica,
        limba, religie, sex, apartenenta politica, venit sau origine sociala.
        Acelasi act normativ prevede egalitatea cetatenilor in fata legii si a
        autoritatilor, fara privilegii si fara discriminare. In cadrul companiei
        vom asigura proiectarea si adaptarea locurilor de muncă în așa fel încât
        acestea să devină accesibile persoanelor cu diferite dizabilități, la
        fel vom proceda cu echipamentele din dotare, in cazul in care vom avea
        angajati cu dizabilități. Aceste operatiuni le vom sustine logistic si
        financiar din veniturile societății. Se va face instructaj specializat
        persoanelor cu dizabilități pentru folosirea in sigurantă a
        echipamentelor. Partea de salarizare va fi calculata si platita pentru
        toată lumea in acelasi mod, pentru femei si bărbati, persoane de etnie
        roma, etc. Pentru clientii, persoane cu dizabilități se vor creea
        intrari adecvate si vor primi facilități pentru a le ușura deplsările in
        cadrul service-ului.
      </p>
      <p style={{ color: "black", marginTop: "50px" }}>
        „Conţinutul acestui material nu reprezintă în mod obligatoriu poziţia
        oficială a Uniunii Europene sau a Guvernului României”
      </p>
      <p style={{ color: "blue", marginTop: "50px" }}>www.fonduri-ue.ro</p>
      <p style={{ color: "black", marginTop: "10px", marginBottom: "50px" }}>
        Pentru informaţii detaliate despre celelalte programe cofinanţate de
        Uniunea Europeană, vă invităm să vizitaţi
        <span style={{ marginLeft: "10px" }}>
          <a href="www.fonduri-ue.ro" target="_blank">
            www.fonduri-ue.ro
          </a>
        </span>
      </p>
    </>
  );
};
